import { RootState } from 'data/store';

export const selectUser = (state: RootState) => state.microsoft.user;
